import { render, staticRenderFns } from "./SystemIntegrations.vue?vue&type=template&id=44bad937&scoped=true"
import script from "./SystemIntegrations.vue?vue&type=script&lang=js"
export * from "./SystemIntegrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bad937",
  null
  
)

export default component.exports